import { useContext, useMemo } from 'react';
import { useTheme } from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { PTO_TYPES } from '../../constants';

const PTO_LABELS = {
  [PTO_TYPES.Holiday]: 'vacation',
  [PTO_TYPES.SickDay]: 'sick',
  [PTO_TYPES.TimeOffInLieu]: 'timeOffInLieu'
};

const usePtoTypes = () => {
  const { t } = useContext(ConfigContext);
  const theme = useTheme();

  const colors = useMemo(
    () =>
      [
        theme.colors.palette[4],
        theme.colors.palette[3],
        theme.colors.palette[5],
        theme.colors.palette[6]
      ].map(({ dark, light }) => ({ color: dark, background: light })),
    [theme.colors.palette]
  );

  const ptoTypesOptions = useMemo(() => {
    return Object.keys(PTO_TYPES).map((key) => ({ value: key, label: t(PTO_LABELS[key]) }));
  }, [t]);

  const mappedPtoTypes = useMemo(
    () =>
      ptoTypesOptions.reduce(
        (prev, { value, label }, index) => ({ ...prev, [value]: { label, ...colors[index % colors.length] } }),
        {}
      ),
    [colors, ptoTypesOptions]
  );

  return { ptoTypesOptions, mappedPtoTypes };
};

export default usePtoTypes;
